export default "__VITE_ASSET__BLG3Ey$v__"